export enum ResolutionStatus {
  ACTIVE = 'active',
  REJECTED = 'rejected',
  ACCEPTED = 'accepted',
  STOPPED = 'stopped',
  DRAFT = 'draft'
}

export enum ResolutionVote {
  YES = 'yes',
  NO = 'no',
  HOLD = 'hold'
}

export enum ResolutionHistoryType {
  ADDED = 'added',
  MODIFIED = 'modified',
  /** voting started */
  OPENED = 'opened',
  REMOVED = 'removed',
  STOPPED = 'stopped',
  ACCEPTED = 'accepted',
  REJECTED = 'rejected',
  /** result published */
  PUBLISHED = 'published',
  /** @deprecated OPENED or PUBLISHED - don't use, don't ask */
  LEGACY_PUB = 'leg_pub'
}
